import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const defaultState = {
  isPaypalAvailable: false,
  setIsPaypalAvailable: Function.prototype,
  isPaypalRendered: false,
  setIsPaypalRendered: Function.prototype,
  paypalCheckoutClient: '',
  setPaypalCheckoutClient: Function.prototype,
  brainTreeClient: '',
  setBrainTreeClient: Function.prototype,
  isPaypalAuthorized: false,
  setIsPaypalAuthorized: Function.prototype,
  paypalButtonType: '',
  setPaypalButtonType: Function.prototype,
  isPaypalButtonRendered: false,
  setIsPaypalButtonRendered: Function.prototype,
  isTravelInsuranceEnabledForPaypal: false,
  setTravelInsuranceEnabledForPaypal: Function.prototype,
  paypalBannersEnabled: false,
  setPaypalBannersEnabled: Function.prototype,
};

export const PaypalStateContext = createContext(defaultState);
export const usePaypalState = () => useContext(PaypalStateContext);

const PaypalStateProvider = props => {
  const [isPaypalAvailable, setIsPaypalAvailable] = useState(false);
  const [paypalCheckoutClient, setPaypalCheckoutClient] = useState('');
  const [brainTreeClient, setBrainTreeClient] = useState('');
  const [isPaypalRendered, setIsPaypalRendered] = useState(false);
  const [isPaypalAuthorized, setIsPaypalAuthorized] = useState(false);
  const [paypalButtonType, setPaypalButtonType] = useState('');
  const [isPaypalButtonRendered, setIsPaypalButtonRendered] = useState(false);
  const [isTravelInsuranceEnabledForPaypal, setTravelInsuranceEnabledForPaypal] = useState(false);
  const [paypalBannersEnabled, setPaypalBannersEnabled] = useState(false);

  return (
    <PaypalStateContext.Provider
      value={{
        isPaypalAvailable: isPaypalAvailable,
        setIsPaypalAvailable: setIsPaypalAvailable,
        isPaypalRendered: isPaypalRendered,
        setIsPaypalRendered: setIsPaypalRendered,
        paypalCheckoutClient: paypalCheckoutClient,
        setPaypalCheckoutClient: setPaypalCheckoutClient,
        brainTreeClient: brainTreeClient,
        setBrainTreeClient: setBrainTreeClient,
        isPaypalAuthorized: isPaypalAuthorized,
        setIsPaypalAuthorized: setIsPaypalAuthorized,
        paypalButtonType: paypalButtonType,
        setPaypalButtonType: setPaypalButtonType,
        isPaypalButtonRendered: isPaypalButtonRendered,
        setIsPaypalButtonRendered: setIsPaypalButtonRendered,
        isTravelInsuranceEnabledForPaypal: isTravelInsuranceEnabledForPaypal,
        setTravelInsuranceEnabledForPaypal: setTravelInsuranceEnabledForPaypal,
        paypalBannersEnabled: paypalBannersEnabled,
        setPaypalBannersEnabled: setPaypalBannersEnabled,
      }}
    >
      {props.children}
    </PaypalStateContext.Provider>
  );
};

PaypalStateProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PaypalStateProvider;
